/* eslint-disable max-len */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import './givereview.css';
import { Grid, Rating } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import RatingHoverFeedback from './RatingHoverFeedback';
import WriteFeedback from './WriteFeedback';
import ThankYouPage from './ThankYouPage';
import Loader from '../../Loader';
import Header from '../../Header';

function GiveReview({ baseURL }) {
  const { companyid } = useParams();
  const [companyRating, setCompanyRating] = useState(0);
  const [rating, setRating] = useState(0);
  const [experience, setExperience] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [assistedBy, setAssistedBy] = useState('');
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableDuringSubmit, setDisableDuringSubmit] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getReviewDetails();
    getAllUsers();
  }, [companyid]);

  console.log('rating',rating);
  const getReviewDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/dashboard-review/write-review/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      console.log(response, 'getReviewDetails res');
      if (response?.data?.status === 'success') {
        setData(response?.data?.data?.entity);
        setCompanyRating(response.data.data.entity?.rating_average);
        setLoading(false);
      }
    } catch (err) {
      console.log('getReviewDetails err', err);
    }
  };

  const getAllUsers = async () => {
    try {
      const res = await axios.get(`${baseURL}/dashboard/user-unauthenticated-get-all/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      // console.log("all users", res);
      const filterUser = res?.data?.data?.entity;
      const AssignLabel = filterUser.filter((entry) => !(entry?.role === 'Km' || entry?.role === 'System'));
      setUsers(AssignLabel);
    } catch (err) {
      console.log('getAllUsers err', err);
    }
  };

  const handleSubmit = async () => {
    console.log('submit check');
    setDisableDuringSubmit(true);
    const formData = {
      experience,
      name,
      email,
      rating_stars: rating.toString(),
      assisted_by: assistedBy,
    };
    try {
      const response = await axios.post(
        `${baseURL}/dashboard-review/write-review/${companyid}`,
        formData,
        
      );
      console.log(response, 'handleSubmit res');
      if (response.data.status === 'success') {
        //   setData(response?.data?.data);
        setPage(page + 1);
        setDisableDuringSubmit(false);
      }
    } catch (err) {
      console.log('handleSubmit err', err);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      {data && (      
      <div className="qs-card">
        <Header 
          logo={data?.display?.email_logo}
          headerColor={data?.display?.email_header_color}
          headerTextColor={data?.display?.email_header_text_color}
          companyName={data?.company?.name}
          ratingValue={data.rating_average === null ? null : Number(Math.round((data?.rating_average) * 10) / 10)}
          reviewCount={data?.review_count}
        />

        <div>
          {page === 1 && (
            <div>
              <div className="qs-card-body flex flex-col items-center qs-fade-in">
                {/* <h3 className="pane-text">{data?.message}</h3> */}
                <h3 className="qs-title">{data?.message}</h3>
                <div className="flex w-full justify-center">
                  <div>
                    <RatingHoverFeedback
                      value={rating}
                      style={{
                        justifyContent: 'center',
                        // display: "table",
                        margin: '28px auto 32px',
                        padding: '0',
                      }}
                      setValue={setRating}
                    />
                  </div>
                </div>
                
                <div className="w-full sm:mx-auto sm:max-w-[280px]">
                  <button
                    disabled={rating === 0}
                    className={rating === 0 ? 'qs-btn bg-slate-200 text-slate-500 shadow-none' : 'qs-btn qs-btn-primary'}
                    onClick={() => setPage(page + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}

          <div>
            {page === 2 && (
              <WriteFeedback
                experience={experience}
                setExperience={setExperience}
                name={name}
                setName={setName}
                email={email}
                setEmail={setEmail}
                assistedBy={assistedBy}
                setAssistedBy={setAssistedBy}
                handleSubmit={handleSubmit}
                data={data}
                users={users}
                loading={disableDuringSubmit}
              />
            )}
          </div>

          <div>
            {page === 3 && (
            <ThankYouPage
              baseURL={baseURL}
              value={data}
              companyId={companyid}
            />
            )}

          </div>
        </div>
      </div>
      )}
    </div>
  );
}

export default GiveReview;
